require('slick-carousel');

if($(".quote-highlights").length) {

    $('.quote-item').on('click', function () {

        // if($(this).hasClass('active')) {
        //     $(this).removeClass('active');
        // } else {
        //     $('.quote-item').not($(this)).removeClass('active');
        //     $(this).addClass('active');
        // }

    });

    if($(window).width() <= 991) {

        $('.quotes-row').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
        });

    }

}
